import React from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '@opendate-app/setlist';

export const ADDRESS_FIELDS = ['address1', 'address2', 'city', 'address_state', 'zip'];
const REQUIRED_ADDRESS_FIELDS = ['address1', 'city', 'address_state', 'zip'];

export const phoneValid = (phone) => {
  const digits = phone.replace(/\D/g, '');
  const national = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  return phone.trim() === '' || /^[2-9]\d{2}[2-9]\d{6}$/.test(national);
};

export const contactComplete = (contact, { collectAddress, collectPhone }) =>
  (!collectPhone || collectPhone === 'off' || phoneValid(contact.phone_number)) &&
  (collectAddress !== 'required' || REQUIRED_ADDRESS_FIELDS.every((field) => contact[field].trim().length > 0)) &&
  (collectPhone !== 'required' || contact.phone_number.trim().length > 0);

export const contactPayload = (contact, { collectAddress, collectPhone }) => ({
  ...(collectAddress && collectAddress !== 'off' && Object.fromEntries(ADDRESS_FIELDS.map((field) => [field, contact[field]]))),
  ...(collectPhone && collectPhone !== 'off' && { phone_number: contact.phone_number }),
});

const MemberContactFields = ({ contact, onChange, collectAddress, collectPhone }) => {
  const showAddress = collectAddress === 'optional' || collectAddress === 'required';
  const showPhone = collectPhone === 'optional' || collectPhone === 'required';
  if (!showAddress && !showPhone) return null;

  const addressRequired = collectAddress === 'required';
  const field = (name, label, required, props = {}) => (
    <TextInput
      id={`membership-${name.replace('_', '-')}`}
      label={label}
      required={required}
      value={contact[name]}
      onChange={(e) => onChange({ ...contact, [name]: e.target.value })}
      {...props}
    />
  );

  return (
    <div style={{ marginTop: "20px" }}>
      {showAddress && (
        <>
          <div className="mb-3">{field('address1', 'Mailing address', addressRequired, { autoComplete: 'address-line1' })}</div>
          <div className="mb-3">{field('address2', 'Apt, suite, etc.', false, { autoComplete: 'address-line2' })}</div>
          <div className="row">
            <div className="col-md-5 mb-3">{field('city', 'City', addressRequired, { autoComplete: 'address-level2' })}</div>
            <div className="col-md-3 mb-3">{field('address_state', 'State', addressRequired, { autoComplete: 'address-level1' })}</div>
            <div className="col-md-4 mb-3">{field('zip', 'ZIP code', addressRequired, { autoComplete: 'postal-code' })}</div>
          </div>
        </>
      )}
      {showPhone && (
        <div className="mb-3">{field('phone_number', 'Phone', collectPhone === 'required', { type: 'tel', autoComplete: 'tel', error: phoneValid(contact.phone_number) ? undefined : 'Enter a valid phone number.' })}</div>
      )}
    </div>
  );
};

MemberContactFields.propTypes = {
  contact: PropTypes.shape({
    address1: PropTypes.string.isRequired,
    address2: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    address_state: PropTypes.string.isRequired,
    zip: PropTypes.string.isRequired,
    phone_number: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  collectAddress: PropTypes.oneOf(['off', 'optional', 'required']),
  collectPhone: PropTypes.oneOf(['off', 'optional', 'required']),
};

MemberContactFields.defaultProps = {
  collectAddress: 'off',
  collectPhone: 'off',
};

export default MemberContactFields;
